import { releases, comics } from "@/mocks/comics";
import SectionHeading from "./SectionHeading";

export default function NewReleases() {
  return (
    <section id="new" className="bg-background-100/70 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="新作速递"
          title="最近更新抢先看"
          subtitle="热门作品最新话数实时更新，标注更新时间，让你第一时间追更，不错过任何精彩内容。"
        />

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {releases.map((release) => {
            const comic = comics.find((c) => c.id === release.comicId);
            if (!comic) return null;
            return (
              <a
                key={release.comicId}
                href="#featured"
                className="group flex items-center gap-4 rounded-2xl border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 hover:bg-background-100"
              >
                <div className="relative h-20 w-14 shrink-0 overflow-hidden rounded-lg bg-background-100 md:h-24 md:w-16">
                  <img
                    src={comic.cover}
                    alt={`${comic.title}封面`}
                    className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="truncate font-heading text-base text-foreground-950">
                    {comic.title}
                  </h3>
                  <p className="mt-0.5 text-xs text-foreground-500">{comic.author}</p>
                  <div className="mt-2 flex flex-wrap gap-1.5">
                    <span className="inline-flex items-center gap-1 rounded-full bg-primary-100 px-2 py-0.5 text-[11px] font-medium text-primary-700">
                      <i className="ri-file-text-line" aria-hidden="true"></i>
                      {release.chapter}
                    </span>
                    <span className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-700">
                      <i className="ri-time-line" aria-hidden="true"></i>
                      {release.updateAt}
                    </span>
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}